/*import React, { useContext, useEffect, useState } from 'react'
import { handleRedirectInternal } from '../../../common/components'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../../product/components/atoms/SecondaryButton'
// import CustomInput from '../../../../product/components/atoms/Inputs/CustomInput'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import authContext from '../../../../product/context/auth/authContext'
import CustomDialog from '../../organisms/Dialog'
import { Button } from '@material-ui/core'
import * as Yup from 'yup'
import { mapData } from '../../../../product/common/components'
import BuynowContext from '../../../../product/context/buynow/buynowContext'
import AlertContext from '../../../../product/context/alert/alertContext'

const Makeoffer = (props) => {
    const { user, isAuthenticated } = useContext(authContext)
    const { setAlert } = useContext(AlertContext)
    const { addToMakeoffer, responseStatus } = useContext(BuynowContext)
    const [product, setProduct] = useState()

    const history = useHistory()

    const [toggleDialog, setToggleDialog] = useState(false)

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    useEffect(() => {
        if (product) {
            formik.setFieldValue('product_id', product.id)
        }
    }, [product])

    const validationArray = Yup.object({
        product_id: Yup.number().required('product id required'),
        offeramount: Yup.number().min(1).required('enter the amount'),
    })

    const formik = useFormik({
        initialValues: { product_id: 0, offeramount: 0 },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (toggleDialog) {
                if (user.user_id === product.user_id) {
                    setAlert("You can't make offer to your own product", 'error')
                } else {
                    let cart = []
                    cart.push(values)
                    console.log('Sreekar made a new call add to make offer')
                    addToMakeoffer({ cart })
                }
            }
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.status === 'success') {
                setToggleDialog(false)
                setTimeout(() => {
                    handleRedirectInternal(history, 'buynowcart')
                }, 2000)
            }
        }
    }, [responseStatus])

    const makeofferQuantity = [
        {
            label: 'Enter Amount',
            name: 'offeramount',
            type: 'number',
            placeholder: `${'Min Quantity'} ${product ? props.next_bid : 0}`,
            class: '',
            size: 'small',
            autoFocus: false,
            formik: formik,
        },
    ]

    useEffect(() => {
        if (product) {
            formik.values.offeramount = product.offeramount
        }
    }, [product])

    return (
        <>
            {product ? (
                <>
                    {product.market_status === 'open' && product.wprice < product.bprice ? (
                        <form onSubmit={formik.handleSubmit}>
                            <div className="biddingCnt beforeLogin d-flex justify-content-between align-items-start">
                                {Object.values(mapData(makeofferQuantity))}
                                {isAuthenticated ? (
                                    <SecondaryButton
                                        label="Make Offer"
                                        type="submit"
                                        btnSize="small"
                                        // onClick={() => changeDialogStatus()}
                                    />
                                ) : (
                                    <SecondaryButton
                                        label="Login to buy"
                                        btnSize="small"
                                        onClick={() => handleRedirectInternal(history, 'login')}
                                    />
                                )}
                            </div>
                        </form>
                    ) : null}
                </>
            ) : null}
            <CustomDialog title="Confirm buy now" open={toggleDialog} function={changeDialogStatus}>
                <h5>You are about to buy this product</h5>
                <h5>Please confirm if you want to continue with this action</h5>
                <div className="actionWrapper">
                    <Button onClick={() => setToggleDialog(false)}>Cancel</Button>
                    <PrimaryButton onClick={formik.handleSubmit} type="submit" label="submit" />
                </div>
            </CustomDialog>
        </>
    )
}

export default Makeoffer
*/
import React, { useContext, useEffect, useState } from 'react'
import { handleRedirectInternal } from '../../../common/components'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../../product/components/atoms/SecondaryButton'
import CustomInput from '../../../../product/components/atoms/Inputs/CustomInput'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import authContext from '../../../../product/context/auth/authContext'
import TertiaryButton from '../../atoms/TertiaryButton'
import CustomDialog from '../../organisms/Dialog'
import { Button } from '@material-ui/core'
import * as Yup from 'yup'
import { mapData } from '../../../../product/common/components'
import BuynowContext from '../../../../product/context/buynow/buynowContext'
import AlertContext from '../../../../product/context/alert/alertContext'

const Makeoffer = (props) => {
    const { user, isAuthenticated } = useContext(authContext)
    const { setAlert } = useContext(AlertContext)
    const { addToMakeOffer, responseStatus } = useContext(BuynowContext)
    const [product, setProduct] = useState()

    const history = useHistory()

    const [toggleDialog, setToggleDialog] = useState(false)

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    useEffect(() => {
        if (product) {
            formik.setFieldValue('product_id', product.id)
        }
    }, [product])

    const validationArray = Yup.object({
        product_id: Yup.number().required('product id required'),
        qty: Yup.number().min(1).required('enter quantity'),
        amount: Yup.number().min(1).required('enter Amount'),
    })

    const formik = useFormik({
        initialValues: { product_id: 0, qty: 0 },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (toggleDialog) {
                if (user.user_id === product.user_id) {
                    setAlert("You can't buy your own product", 'error')
                } else {
                    let cart = []
                    cart.push(values)
                    addToMakeOffer({ cart })
                }
            }
            if (values.qty > 0) setToggleDialog(true)
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'addToMakeoffer') {
                if (responseStatus.status === 'success') {
                    setToggleDialog(false)
                    setTimeout(() => {
                        handleRedirectInternal(history, 'alloffers')
                    }, 2000)
                }
            }
        }
    }, [responseStatus])
    const makeofferQuantity = [
        {
            label: 'Enter Offer Amount',
            name: 'amount',
            type: 'number',
            class: '',
            size: 'small',
            autoFocus: false,
            formik: formik,
        },
        {
            label: 'Enter Quantity',
            name: 'qty',
            type: 'number',
            placeholder: `${'Max Quantity'} ${product ? product.qty - product.sold : 0}`,
            class: '',
            size: 'small',
            autoFocus: false,
            formik: formik,
        },
    ]

    useEffect(() => {
        if (product) {
            formik.values.qty = product.qty - product.sold
        }
    }, [product])

    return (
        <>
            {product ? (
                <>
                    {product.market_status === 'open' ? (
                        <form onSubmit={formik.handleSubmit}>
                            <div className="biddingCnt beforeLogin d-flex justify-content-between align-items-start">
                                {Object.values(mapData(makeofferQuantity))}
                                {isAuthenticated ? (
                                    <SecondaryButton
                                        label="Make Offer"
                                        type="submit"
                                        btnSize="small"
                                        // onClick={() => changeDialogStatus()}
                                    />
                                ) : (
                                    <SecondaryButton
                                        label="Login to buy"
                                        btnSize="small"
                                        onClick={() => handleRedirectInternal(history, 'login')}
                                    />
                                )}
                            </div>
                        </form>
                    ) : null}
                </>
            ) : null}
            <CustomDialog title="Confirm Offer" open={toggleDialog} function={changeDialogStatus}>
                <h5>You are about to make an offer for this product</h5>
                <h5>Please confirm if you want to continue with this action</h5>
                <div className="actionWrapper">
                    <Button onClick={() => setToggleDialog(false)}>Cancel</Button>
                    <PrimaryButton onClick={formik.handleSubmit} type="submit" label="submit" />
                </div>
            </CustomDialog>
        </>
    )
}

export default Makeoffer
